import React from 'react';
import { Reveal } from './Reveal';
const INSTRUCTOR_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/0eb257f6-e507-4725-84a9-8ec9134da99f.jpg';
const logros = [{
  valor: '+500',
  label: 'Alumnas formadas'
}, {
  valor: '+8',
  label: 'Años de experiencia'
}, {
  valor: '+300',
  label: 'Eventos realizados'
}];
export function Instructora() {
  return <section className="w-full bg-[#f6f1fb] py-24" data-id="element-83" data-mp="2xl4zmu57ftk0">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-6 lg:grid-cols-2" data-id="element-84" data-mp="2xlwyqey0g9f1">
        <Reveal data-id="element-85" data-mp="2sn3g683v9s80">
          <div className="relative" data-id="element-86" data-mp="2snlmjxk8tmtn">
            <div className="absolute -inset-4 -z-10 rounded-[2rem] bg-[#a78bdb]/20" data-id="element-87" data-mp="37ayafsxiw4n7" />
            <img src={INSTRUCTOR_IMG} alt="La instructora del curso sosteniendo globos rosados y dorados" className="h-full w-full rounded-[1.75rem] object-cover shadow-lg" data-id="element-88" data-mp="37d17uy10901y" />
          </div>
        </Reveal>

        <Reveal delay={0.1} data-id="element-89" data-mp="29urhbvcf992m">
          <div data-id="element-90" data-mp="29tgf3zymk9dm">
            <p className="text-sm font-semibold uppercase tracking-widest text-[#c9a227]" data-id="element-91" data-mp="2qbiggn7iy2fg">
              Sobre la instructora
            </p>
            <h2 className="font-display mt-3 text-3xl font-semibold text-[#2f2a33] sm:text-4xl" data-id="element-92" data-mp="2uc2d7po6r412">
              Camila Rossi
            </h2>
            <p className="mt-1 text-lg text-[#a78bdb]" data-id="element-93" data-mp="2z5x4pfa18nap">
              Decoradora profesional y emprendedora
            </p>

            <p className="mt-6 text-lg leading-relaxed text-[#2f2a33]/80" data-id="element-94" data-mp="27cxs32x0pb5i">
              Empecé decorando el cumpleaños de mi hija con unos pocos globos y
              muchas ganas. Lo que arrancó como un hobby se convirtió en mi
              fuente de ingresos y en mi pasión. Hoy quiero enseñarte todo lo
              que aprendí en estos años para que vos también puedas vivir de lo
              que te gusta.
            </p>

            <div className="mt-8 grid grid-cols-3 gap-4" data-id="element-95" data-mp="3rrgahhbv8uia">
              {logros.map(l => <div key={l.label} className="rounded-2xl bg-white p-4 text-center shadow-sm" data-id="element-96" data-mp="l5e3yhswhxa">
                  <p className="font-display text-2xl font-semibold text-[#ec4899]" data-id="element-97" data-mp="3759x5qdqe4zv">
                    {l.valor}
                  </p>
                  <p className="mt-1 text-xs text-[#2f2a33]/60" data-id="element-98" data-mp="3h1whme25au1d">{l.label}</p>
                </div>)}
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}